module.exports = __webpack_public_path__ + "static/media/minus-icon.64542881.svg";